/**
 * Per-product discount in the badge  ([product_percent])
 *
 * Two tokens, two different numbers:
 *
 *   [percent]          the site-wide Display Discount setting. Resolved in Liquid
 *                      in sections/support-product-badges.liquid, so it is the same
 *                      number on every card and it only exists during a display-only
 *                      promotion.
 *   [product_percent]  THIS product's actual discount, worked out per product by
 *                      snippets/product-sale-state.liquid and handed to the element
 *                      as data-sale-percent. Works for real compare-at pricing, where
 *                      every product is marked down by a different amount.
 *
 * WHY A SEPARATE, UNHASHED FILE: the badge component (ProductBadge-1c917ee3.js) is
 * bundler output whose source is not in this repo. It writes the badge text once, in
 * connectedCallback, straight from the JSON config - it has no idea a per-product
 * number exists. Rather than edit a hashed bundle, this file rewrites the token after
 * the fact.
 *
 * WHY A MutationObserver rather than a pass on DOMContentLoaded: custom elements
 * upgrade whenever they upgrade, so this file can run either side of the component's
 * own render; and the collection grid replaces its cards on filter and paginate. An
 * observer covers all of it. Our own write is idempotent - the token is gone
 * afterwards, so the resulting mutation is a no-op.
 *
 * A qualifying product with no usable percentage gets an empty badge, which the
 * component stylesheet already hides via product-badge:has(.content:empty).
 */
(function () {
  'use strict';

  var TOKEN = '[product_percent]';
  var CONTENT_SELECTOR = '[data-product-badge-element="content"]';

  function apply(badge) {
    if (!badge || !badge.querySelector) return;

    var content = badge.querySelector(CONTENT_SELECTOR);
    if (!content) return;

    var text = content.textContent;
    if (!text || text.indexOf(TOKEN) === -1) return;

    var percent = parseInt(badge.getAttribute('data-sale-percent'), 10);

    if (isNaN(percent) || percent <= 0) {
      content.textContent = '';
      return;
    }

    content.textContent = text.split(TOKEN).join(String(percent));
  }

  function sweep(node) {
    if (!node) return;

    if (node.nodeType === 1 && node.matches && node.matches('product-badge')) {
      apply(node);
    }

    if (!node.querySelectorAll) return;

    var badges = node.querySelectorAll('product-badge');
    for (var i = 0; i < badges.length; i++) apply(badges[i]);
  }

  function badgeFor(node) {
    var el = node.nodeType === 1 ? node : node.parentElement;
    return el && el.closest ? el.closest('product-badge') : null;
  }

  function start() {
    sweep(document);

    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];
        var badge = badgeFor(mutation.target);

        if (badge) {
          apply(badge);
          continue;
        }

        for (var j = 0; j < mutation.addedNodes.length; j++) {
          sweep(mutation.addedNodes[j]);
        }
      }
    }).observe(document.documentElement, {
      subtree: true,
      childList: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
